<template>
  <Drawer title="指令下发" v-model="openDrawer">
    <p style="margin-bottom: 20px">断电可能存在安全风险，请谨慎下发</p>
    <Button @click="duankai" type="error">断开油电</Button>
    <Button @click="chongqi" type="primary">恢复油电</Button>
  </Drawer>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      openDrawer: false,
    };
  },
  methods: {
    open(v) {
      this.openDrawer = true;
      this.item = v;
    },
    duankai() {

      var parm = {
        deviceIdList: [this.item.deviceId],
        template: "{}",
        cmdTypeId: 61,
      };
      axios({
        method: "post",
        url: axios.cmd + "/cmdMsg/issue",
        data: parm,
      }).then((res) => {
        if (res.data.code != 200) {
          this.$Message.error(res.data.message);
        } else {
          this.openDrawer = false;
          this.$Message.success("指令已下发");
        }
      });
    },
    chongqi() {
      var parm = {
        deviceIdList: [this.item.deviceId],
        template: "{}",
        cmdTypeId: 62,
      };
      axios({
        method: "post",
        url: axios.cmd + "/cmdMsg/issue",
        data: parm,
      }).then((res) => {
        if (res.data.code != 200) {
          this.$Message.error(res.data.message);
        } else {
          this.openDrawer = false;
          this.$Message.success("指令已下发");
         
        }
      });
    },

  },
};
</script>


// WEBPACK FOOTER //
// src/components/locate/com/zhiling.vue